export class FetchAndApplyPreferredLocale {
  static readonly type = '[Locale] Fetch and apply preferred locale';
}

export class PersistPreferredLocale {
  static readonly type = '[Locale] Persist preferred locale';
  constructor(public locale: string) {}
}
